import { render } from "./VTextFieldAlgolia.vue?vue&type=template&id=5b1a1243"
import script from "./VTextFieldAlgolia.vue?vue&type=script&lang=js"
export * from "./VTextFieldAlgolia.vue?vue&type=script&lang=js"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__